<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'News', route: '/backoffice/news/' }, { label: 'Modifica News', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">MODIFICA NEWS</h1>
</section>


<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formNews" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                                
            <div class="w-full">
                <label>* Data</label>
                <br />
                <p-calendar formControlName="data" class="w-full grid" dateFormat="dd/mm/yy" [showIcon]="true" />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formNews.get('data')?.hasError('required') && (formNews.get('data')?.dirty || formNews.get('data')?.touched)">La data è obbligatoria!.</small>
            </div>
            <div class="w-full">
                <label>* Titolo</label>
                <input type="text" pInputText placeholder="Titolo" formControlName="titolo" name="titolo" id="titolo" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formNews.get('titolo')?.hasError('required') && (formNews.get('titolo')?.dirty || formNews.get('titolo')?.touched)">Il titolo è obbligatorio!.</small>
            </div>                                   
            <div class="w-full">
                <label>Descrizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
            </div>       
            
            <div class="flex lg:flex-row flex-col justify-start w-full items-center">

                <div class="w-full" [ngClass]="{'lg:w-1/2' : formNews.get('link')?.value && formNews.get('link')?.value.length > 0}">
                    <p-checkbox label="Evidenzia" formControlName="evidenzia" value="evidenzia" class="flex justify-center" pTooltip="Se selezionato, la news verrà mostrate tra le prime posizioni" tooltipPosition="top" />
                </div>
                
                <div class="w-full flex flex-col gap-8" [ngClass]="{'lg:w-1/2' : formNews.get('link')?.value && formNews.get('link')?.value.length > 0 }">
                    <p-checkbox label="Link" formControlName="link" value="link"  class="flex justify-center" (ngModelChange)="onLink($event)" pTooltip="Se selezionato, il pulsante 'Scopri di più' della news porterà al link inserito nel campo 'Url Link'" tooltipPosition="top" />
                    <div class="w-full" *ngIf="formNews.get('link')?.value && formNews.get('link')?.value.length > 0">
                        <label>* Url Link</label>
                        <input type="text" pInputText placeholder="Link" formControlName="link_url" name="link_url" id="link_url"  />
                        <small class="text-red-600 block mt-4 font medium" *ngIf="formNews.get('link_url')?.hasError('required') && (formNews.get('link_url')?.dirty || formNews.get('link_url')?.touched)"> Inserire una data valida</small>
                    </div>
                </div>
                
            </div>
                        
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formNews.valid">Modifica news</button>
                </div>
                <div class="lg:w-1/2 w-full">
                    <p-confirmPopup #confirmDeletePopupRef>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                    <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnulla()" label="Annulla" />
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <button class="btn-danger-backoffice p-3 w-full font-medium" type="button" (click)="onDeleteNewsPopup($event)">Elimina news</button>
                </div>
            </div>                                
        </div>
    </form>
</section>